// Formatação de datas sem shift de fuso.
//
// O backend envia colunas DATE como 'YYYY-MM-DD' (pool com dateStrings:['DATE']).
// Datas antigas/serializadas podem chegar como ISO com 'Z' ('2026-08-30T00:00:00.000Z').
// Em ambos os casos a parte da data já está correta — o bug do -1 dia acontece
// quando o frontend faz `new Date(isoString)` e reparseia em UTC.
// Estas funções NUNCA constroem um Date a partir do valor recebido.

/** '2026-08-30' | '2026-08-30T00:00:00.000Z' | Date -> '30/08/2026' */
export function formatDateBR(v) {
  if (!v) return '—';
  const s = String(v).slice(0, 10); // 'YYYY-MM-DD'
  const [y, m, d] = s.split('-');
  if (!y || !m || !d) return '—';
  return `${d}/${m}/${y}`;
}

/** Data de hoje no fuso LOCAL como 'YYYY-MM-DD' (para defaults de <input type="date">). */
export function todayLocalISO() {
  const n = new Date();
  const mm = String(n.getMonth() + 1).padStart(2, '0');
  const dd = String(n.getDate()).padStart(2, '0');
  return `${n.getFullYear()}-${mm}-${dd}`;
}

/** Idade em dias entre 'YYYY-MM-DD' e hoje, sem erro de fuso. */
export function ageInDays(birth, ref) {
  if (!birth) return null;
  const b = String(birth).slice(0, 10).split('-').map(Number);
  if (b.length !== 3 || !b[0]) return null;
  const bUTC = Date.UTC(b[0], b[1] - 1, b[2]);
  let rUTC;
  if (ref) {
    const r = String(ref).slice(0, 10).split('-').map(Number);
    rUTC = Date.UTC(r[0], r[1] - 1, r[2]);
  } else {
    const n = new Date();
    rUTC = Date.UTC(n.getFullYear(), n.getMonth(), n.getDate());
  }
  return Math.floor((rUTC - bUTC) / 86400000);
}

/** Quantos dias tem um mês (1-indexado) de um ano. */
function diasNoMes(ano, mes1indexado) {
  return new Date(ano, mes1indexado, 0).getDate();
}

/**
 * Diferença de calendário REAL (anos/meses/dias completos) entre 'YYYY-MM-DD' e hoje (ou ref).
 * Não divide dias por 30/365 — usa os componentes de data, então respeita meses de tamanhos
 * diferentes. null se não houver nascimento ou se a data for no futuro.
 */
export function idadeDetalhada(birth, ref) {
  if (!birth) return null;
  const b = String(birth).slice(0, 10).split('-').map(Number);
  if (b.length !== 3 || !b[0]) return null;
  let r;
  if (ref) {
    r = String(ref).slice(0, 10).split('-').map(Number);
  } else {
    const n = new Date();
    r = [n.getFullYear(), n.getMonth() + 1, n.getDate()];
  }
  const totalDias = ageInDays(birth, ref);
  if (totalDias == null || totalDias < 0) return null;

  let anos = r[0] - b[0];
  let meses = r[1] - b[1];
  let dias = r[2] - b[2];
  if (dias < 0) {
    meses -= 1;
    const mesAnterior = r[1] - 1 === 0 ? 12 : r[1] - 1;
    const anoMesAnterior = r[1] - 1 === 0 ? r[0] - 1 : r[0];
    dias += diasNoMes(anoMesAnterior, mesAnterior);
  }
  if (meses < 0) {
    anos -= 1;
    meses += 12;
  }
  return { anos, meses, dias, totalDias };
}

/**
 * Idade formatada a partir da data de nascimento (NUNCA a partir de idade_dias — total de dias
 * não converte em meses sem as datas reais). < 1 ano -> 'Xm Yd' (ou 'Yd' se X=0); >= 1 ano ->
 * 'Xa Ym' (sem dias).
 */
export function formatIdade(birth, ref) {
  const d = idadeDetalhada(birth, ref);
  if (!d) return '—';
  if (d.anos > 0) return `${d.anos}a ${d.meses}m`;
  if (d.meses > 0) return `${d.meses}m ${d.dias}d`;
  return `${d.dias}d`;
}
